import Swiper from 'swiper/js/swiper.min'

export class Slider {

    constructor ( target = '.js-slider', options = {} ) {

        this.target = target;

        this.options = {
            effect: 'fade',
            startAt: 0,
            slidesPerView: 'auto',
            slideClass: 'js-slider__slide',
            wrapperClass: 'js-slider__track',
            slideActiveClass: 'js-slider__slide--active',
            noSwipingClass: 'js-slider__no-swipe',
            pagination: {
                type: 'custom',
                el: '.js-slider__pagination',
                renderCustom: function( swiper, current, total ) {
                    return `${current} of  ${total}`;
                },
            },
            ...options
        }

        this.observerOptions = {
            observer: {
                root: document.querySelector( 'body' ),
                rootMargin: '0px',
                threshold: 0.01
            },
            removeTarget: true,
            ...options
        }
    }

    init () {

        this.sliders = [];
        this.el = Array.from( document.querySelectorAll( this.target ) );

        if(this.el.length > 0) {
            this.sliderObserver = new IntersectionObserver( ( entries, observer ) => {
                this.create( entries, this )
            }, this.options );

            this.el.forEach( $el => {
                this.sliderObserver.observe( $el );
            } );
        }


    }

    create( entries, instance) {
        entries.forEach( ( entry ) => {
            if ( entry.isIntersecting ) {

                const $el = entry.target;
                const count = Array.from( $el.querySelectorAll( `.${this.options.slideClass}` ) ).length;
                let options = {
                    ...this.options,
                }

                if ( count > 1 ) {
                    let $next = $el.querySelectorAll( '.js-slider__next' );
                    let $prev = $el.querySelectorAll( '.js-slider__prev' );

                    options = {
                        ...this.options,
                        navigation: {
                            nextEl: $next,
                            prevEl: $prev,
                            disabledClass: 'js-slider__control--disabled',
                        },
                    }
                } else {
                    const $controls = $el.querySelector( `.c-gallery__controls` );
                    if($controls) {
                        $controls.remove();
                    }
                }


                this.sliders.push( new Swiper( $el, options ) );
            }
        })
    }

    destroy () {
        if(this.el.length > 0) {
            this.sliderObserver.disconnect();
        }
        this.sliders.forEach( slider => {
            slider.destroy();
        } )
    }
}